import React from "react";

export default function Dashboard() {
  return (
    <div style={{ padding: 24 }}>
      <h1>Dashboard</h1>
      <p>You're signed in via LTI. Load your app content here.</p>
    </div>
  );
}

